// `city`/`region` feed formatLocationSlug and, via the results loader, the
// providers search — they must be the real city/state as the provider data
// spells them ("New York", not the display label "New York City"). `label` is
// the copy shown to the user.
// Alphabetical by label — with the columns filling top-to-bottom, that reads
// down each column the way a viewer scanning for their own city expects.
export const BROWSE_BY_CITY = [
  { label: 'Austin', city: 'Austin', region: 'TX' },
  { label: 'Charlotte', city: 'Charlotte', region: 'NC' },
  { label: 'Chicago', city: 'Chicago', region: 'IL' },
  { label: 'Columbus', city: 'Columbus', region: 'OH' },
  { label: 'Dallas', city: 'Dallas', region: 'TX' },
  { label: 'Denver', city: 'Denver', region: 'CO' },
  { label: 'Fort Worth', city: 'Fort Worth', region: 'TX' },
  { label: 'Houston', city: 'Houston', region: 'TX' },
  { label: 'Indianapolis', city: 'Indianapolis', region: 'IN' },
  { label: 'Jacksonville', city: 'Jacksonville', region: 'FL' },
  { label: 'Los Angeles', city: 'Los Angeles', region: 'CA' },
  { label: 'Miami', city: 'Miami', region: 'FL' },
  { label: 'New York City', city: 'New York', region: 'NY' },
  { label: 'Philadelphia', city: 'Philadelphia', region: 'PA' },
  { label: 'Phoenix', city: 'Phoenix', region: 'AZ' },
  { label: 'San Antonio', city: 'San Antonio', region: 'TX' },
  { label: 'San Diego', city: 'San Diego', region: 'CA' },
  { label: 'San Francisco', city: 'San Francisco', region: 'CA' },
  { label: 'San Jose', city: 'San Jose', region: 'CA' },
  { label: 'Seattle', city: 'Seattle', region: 'WA' },
  { label: 'Washington, DC', city: 'Washington', region: 'DC' },
] as const
